import type { AloftDate, XMLPropertyResult } from '@aloft/toolkit-shared';

import { extractEffectiveDate } from './extractEffectiveDate.ts';
import { extractPropertyResult } from './extractPropertyResult.ts';
import { extractSubjectResult } from './extractSubjectResult.ts';

/**
 * Extracts the property information from the UAD xml document
 *
 * @param doc an XML document that has parsed into a Document object
 * @returns a list of properties and their adjustments
 */
export const extractXMLPropertyResults = (
  doc: Document,
): {
  subject: XMLPropertyResult;
  comps: XMLPropertyResult[];
  effectiveDate: AloftDate | undefined;
  formType: string;
} => {
  const comparableSales = [...doc.getElementsByTagName('COMPARABLE_SALE')];

  const subjectSale = comparableSales[0];
  if (!subjectSale) throw new Error('Missing subject');

  const { subject, featureLabels, formType, defaultPropertyType } = extractSubjectResult(doc);
  const effectiveDate = extractEffectiveDate(doc);

  return {
    subject,
    comps: Array.from(comparableSales.slice(1)).map((sale) => {
      const compProperty = extractPropertyResult(
        sale,
        { t: 'comparable', labels: featureLabels },
        defaultPropertyType,
      );

      return {
        ...compProperty,
        foundation: defaultPropertyType === 'manufacturedHome' ? 'pierAndBeam' : undefined,
      };
    }),
    effectiveDate,
    formType,
  };
};
